import {Link} from 'react-router-dom'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import {useContext, useState} from 'react'
import {SalesRepReportContext} from '../../context'
import { MIN_DATE_RANGE } from '../../utils'

const SalesRepReportRow = ({row}: any) => {
  const [showChartModal, setShowChartModal] = useState(false)
  const {
    onSalesRepEntityPerformanceChartIdChange,
    onSalesRepEntityPerformanceChartViewChange,
    onSalesRepEntityPerformanceChartDateRangeChange,
    salesRepEntityPerformanceChartFilters,
    isSalesRepEntityPerformanceChartDataLoading,
    salesRepEntityPerformanceChartData,
  } = useContext(SalesRepReportContext)

  return (
    <>
      <tr>
        <td>{row.salesRep}</td>
        <td>{row.salesRepEmail}</td>
        <td>{row.salesRepType}</td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&sales_rep=${row.salesRepEmail}`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.order}
          </Link>
        </td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&sales_rep=${row.salesRepEmail}&coupon_code_type=freeship`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.freeship}
          </Link>
        </td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&sales_rep=${row.salesRepEmail}&coupon_code_type=sf`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.sf_coupon}
          </Link>
        </td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&sales_rep=${row.salesRepEmail}&coupon_code_type=sll`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.sll}
          </Link>
        </td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&sales_rep=${row.salesRepEmail}&coupon_code_type=5offoneorder`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.five_percent_off}
          </Link>
        </td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&sales_rep=${row.salesRepEmail}&coupon_code_type=other`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.other_coupon}
          </Link>
        </td>
        <td>{row.couponCodeValue}</td>
        <td>{row.contributedCouponPercentage}</td>
        <td>
          <div className='d-flex justify-content-end'>
            <span
              onClick={() => setShowChartModal(true)}
              className='w-30px h-30px d-flex justify-content-center align-items-center text-primary cursor-pointer'
            >
              <i className='fas fa-chart-line text-primary'></i>
            </span>
          </div>
        </td>
      </tr>
      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={row.salesRepEmail}
          entityName={`Coupon Code Report - ${row.salesRepEmail}`}
          onEntityPerformanceChartIdChange={onSalesRepEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onSalesRepEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={onSalesRepEntityPerformanceChartDateRangeChange}
          entityPerformanceChartFilters={salesRepEntityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isSalesRepEntityPerformanceChartDataLoading}
          entityPerformanceChartData={salesRepEntityPerformanceChartData}
          startDate={MIN_DATE_RANGE}
        />
      )}
    </>
  )
}

export default SalesRepReportRow
